<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Datos Generales del Préstamo
              |  
              a.button.is-default.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-6
            .field
              label.label Selecciona el Área
                .control
                  input#area_Inst.is-checkradio(type='radio' v-model="area" value="1" name='sel_area' checked='checked')
                  label.is-size-6(for='area_Inst') Instrum.
                  input#area_Sist.is-checkradio(type='radio' v-model="area" value="3" name='sel_area')
                  label.is-size-6(for='area_Sist') Sist./Telec.
                  input#area_Admin.is-checkradio(type='radio' v-model="area" value="2" name='sel_area')
                  label.is-size-6(for='area_Admin') Admón.
          .column.is-6
            .field
              label.label Recibe
              .control
                Typeahead(:options="usuarios" :optionSelect="usuarioRecibe" :tema="typeTipos" v-model="usuarioRecibe")
        .columns
          .column.is-3
            .field
              label.label Fecha
              .control
                flat-pickr(
                  v-model='fecha'
                  :config="config"
                  class="input is-primary"
                )
          .column.is-3.is-offset-3
            .field
              label.label Destino
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="ubicacionSel")
                    option(value="" checked) Seleccione una Ubicación
                    option(v-for="ubi in ubicaciones" :key="ubi.valor" :value="ubi.valor") {{ ubi.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-map-pin
          .column.is-3
            .field
              label.label Oficina
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="oficinaSelected")
                    option(value="") Selecciona el Sitio
                    option(v-for="data in oficinasSel" :value="data.id" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-tools
          
        .columns(v-show="Object.keys(datosFaltantes).length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns
          .column.is-one-quarter.is-offset.one-quarter
            a.button.is-primary.is-rounded.is-medium(@click="checkForm") Guardar
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Typeahead from './Typeahead.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/plugins/monthSelect/style.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { evall } from '../../configSystem'
  const Cryptr = require('cryptr')
  import moment from 'moment'
  import { mapState } from 'vuex'
  export default {
    name: 'NuevoPrestamo',
    components: { Loader, NavBarInventario, Typeahead, flatPickr },
    data () {
      return {
        isLoading: true,
        area: '3',
        recibe: '',
        oficina: '',
        autoriza: '',
        fecha: null,
        config: {
          wrap: false, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d H:i',
          altInput: true,
          dateFormat: 'Y-m-d H:i',
          locale: Spanish, // locale for this instance only
          enableTime: true
        },
        usuarios_Recibe: [],
        usuarios_Autoriza: [],
        isEditing: false,
        usuarios: [],
        typeTipos: '',
        usuarioRecibe: {},
        datosFaltantes: [],
        itemsGuardados: 0,
        oficinas: [
          { 'id': 'TPA-ALM', 'nombre': 'Almacén', 'source': 'TPA' },
          { 'id': 'TPA-ALS', 'nombre': 'Almacén Sist.', 'source': 'TPA' },
          { 'id': 'TPA-ADM', 'nombre': 'Of. Admin.', 'source': 'TPA' },
          { 'id': 'TPA-CC', 'nombre': 'Cuarto de Control', 'source': 'TPA' },
          { 'id': 'TPA-SERV', 'nombre': 'Servidores', 'source': 'TPA' },
          { 'id': 'TPA-IO', 'nombre': 'Cuarto de IOS', 'source': 'TPA' },
          { 'id': 'TPA-FAC', 'nombre': 'Facturación', 'source': 'TPA' },
          { 'id': 'TPA-BAS', 'nombre': 'Báscula', 'source': 'TPA' },
          { 'id': 'TPA-GER', 'nombre': 'Gerencia', 'source': 'TPA' },
          { 'id': 'TPA-MUE', 'nombre': 'Muelle', 'source': 'TPA' },
          { 'id': 'TPA-MANT', 'nombre': 'Subgerencia de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-TALL', 'nombre': 'Taller de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-SEG', 'nombre': 'Subgerencia de Seguridad', 'source': 'TPA' },
          { 'id': 'TPA-SADM', 'nombre': 'Subgerencia Administrativa', 'source': 'TPA' },
          { 'id': 'TPA-PROP', 'nombre': 'Of. Propangol', 'source': 'TPA' },
          { 'id': 'TPA-NIE', 'nombre': 'Of. Nieto', 'source': 'TPA' },
          { 'id': 'TPA-MOV', 'nombre': 'Of. Movenergy', 'source': 'TPA' },
          { 'id': 'TPA-SJ', 'nombre': 'Sala de Juntas', 'source': 'TPA' },
          { 'id': 'TPA-ACC', 'nombre': 'Accesos', 'source': 'TPA' },
          { 'id': 'TPA-VIG', 'nombre': 'Vigilancia', 'source': 'TPA' },
          { 'id': 'TPA-ESF', 'nombre': 'Esféricos', 'source': 'TPA' },
          { 'id': 'TPA-LLEN', 'nombre': 'Llenaderas', 'source': 'TPA' },
          { 'id': 'TPA-SJ2', 'nombre': 'Sala de Juntas 2', 'source': 'TPA' },
          { 'id': 'TPA-REC', 'nombre': 'Recepción', 'source': 'TPA' },
          { 'id': 'TPA-COM', 'nombre': 'Comedor', 'source': 'TPA' },
          { 'id': 'TPA-SALM', 'nombre': 'SubAlmacén', 'source': 'TPA' },
          { 'id': 'TPA-TRE', 'nombre': 'Área 300', 'source': 'TPA' },
          { 'id': 'IRGE-ALM', 'nombre': 'Almacén', 'source': 'IRGE' },
          { 'id': 'IRGE-ADM', 'nombre': 'Of. Admin.', 'source': 'IRGE' },
          { 'id': 'IRGE-CC', 'nombre': 'Cuarto de Control', 'source': 'IRGE' },
          { 'id': 'IRGE-FAC', 'nombre': 'Facturación', 'source': 'IRGE' },
          { 'id': 'IRGE-BAS', 'nombre': 'Báscula', 'source': 'IRGE' },
          { 'id': 'IRGE-GER', 'nombre': 'Gerencia', 'source': 'IRGE' },
          { 'id': 'IRGE-GADM', 'nombre': 'Gerencia Admn.', 'source': 'IRGE' },
          { 'id': 'IRGE-SJ', 'nombre': 'Sala de Juntas', 'source': 'IRGE' },
          { 'id': 'IRGE-SEG', 'nombre': 'Of. Seguridad', 'source': 'IRGE' },
          { 'id': 'IRGE-IOS', 'nombre': 'Cuarto de IOS', 'source': 'IRGE' },
          { 'id': 'IRGE-PEM', 'nombre': 'Of. Pemex', 'source': 'IRGE' },
          { 'id': 'IRGE-ACC', 'nombre': 'Accesos', 'source': 'IRGE' },
          { 'id': 'IRGE-VIG', 'nombre': 'Vigilancia', 'source': 'IRGE' },
          { 'id': 'IRGE-CE', 'nombre': 'Cuarto Eléctrico', 'source': 'IRGE' },
          { 'id': 'IRGE-REC', 'nombre': 'Recepción', 'source': 'IRGE' },
          { 'id': 'IRGE-OP', 'nombre': 'Operación', 'source': 'IRGE' },
          { 'id': 'IRGE-CCP', 'nombre': 'Cuarto Control Plus', 'source': 'IRGE' },
          { 'id': 'IRGE-VP', 'nombre': '23 Puntos', 'source': 'IRGE' },
          { 'id': 'IRGE-MOV', 'nombre': 'Movenergy', 'source': 'IRGE' },
          { 'id': 'IRGE-VIC', 'nombre': 'Vigilanca CUSAEM', 'source': 'IRGE' },
          { 'id': 'IRGE-OFE', 'nombre': 'Oficina Eléctrica', 'source': 'IRGE' },
          { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
          { 'id': 'EB04-CC', 'nombre': 'Cuarto de Control', 'source': 'EB04' },
          { 'id': 'EB04-ADM', 'nombre': 'Of. Admin.', 'source': 'EB04' },
          { 'id': 'EB04-GER', 'nombre': 'Gerencia', 'source': 'EB04' },
          { 'id': 'EB04-SIS', 'nombre': 'Sistemas', 'source': 'EB04' },
          { 'id': 'EB04-INS', 'nombre': 'Instrumentación', 'source': 'EB04' },
          { 'id': 'EB04-VIG', 'nombre': 'Vigilancia', 'source': 'EB04' },
          { 'id': 'EB04-SG', 'nombre': 'Sala de Juntas', 'source': 'EB04' },
          { 'id': 'EB04-TIA', 'nombre': 'Taller Inst/Aut', 'source': 'EB04' },
          { 'id': 'EB04-ALM', 'nombre': 'Almacén', 'source': 'EB04' },
          { 'id': 'EB03-CC', 'nombre': 'Cuarto de Control', 'source': 'EB03' },
          { 'id': 'EB03-ADM', 'nombre': 'Of. Admin.', 'source': 'EB03' },
          { 'id': 'EB03-VIG', 'nombre': 'Vigilancia', 'source': 'EB03' },
          { 'id': 'EB03-ARC', 'nombre': 'Archivo', 'source': 'EB03' },
          { 'id': 'EB03-COM', 'nombre': 'Comedor', 'source': 'EB03' },
          { 'id': 'EB03-REC', 'nombre': 'Recepción', 'source': 'EB03' },
          { 'id': 'EB03-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB03' },
          { 'id': 'EB03-SV', 'nombre': 'Servicios', 'source': 'EB03' },
          { 'id': 'EB03-TAL', 'nombre': 'Taller', 'source': 'EB03' },
          { 'id': 'EB03-ALM', 'nombre': 'Almacén', 'source': 'EB03' },
          { 'id': 'EB02-CC', 'nombre': 'Cuarto de Control', 'source': 'EB02' },
          { 'id': 'EB02-ADM', 'nombre': 'Of. Admin.', 'source': 'EB02' },
          { 'id': 'EB02-VIG', 'nombre': 'Vigilancia', 'source': 'EB02' },
          { 'id': 'EB02-ARC', 'nombre': 'Archivo', 'source': 'EB02' },
          { 'id': 'EB02-COM', 'nombre': 'Comedor', 'source': 'EB02' },
          { 'id': 'EB02-REC', 'nombre': 'Recepción', 'source': 'EB02' },
          { 'id': 'EB02-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB02' },
          { 'id': 'EB02-ALM', 'nombre': 'Almacén', 'source': 'EB02' },
          { 'id': 'EB01-CC', 'nombre': 'Cuarto de Control', 'source': 'EB01' },
          { 'id': 'EB01-ADM', 'nombre': 'Of. Admin.', 'source': 'EB01' },
          { 'id': 'EB01-VIG', 'nombre': 'Vigilancia', 'source': 'EB01' },
          { 'id': 'EB01-ARC', 'nombre': 'Archivo', 'source': 'EB01' },
          { 'id': 'EB01-COM', 'nombre': 'Comedor', 'source': 'EB01' },
          { 'id': 'EB01-REC', 'nombre': 'Recepción', 'source': 'EB01' },
          { 'id': 'EB01-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB01' },
          { 'id': 'EB01-ALM', 'nombre': 'Almacén', 'source': 'EB01' },
          { 'id': 'EB00-CC', 'nombre': 'Cuarto de Control', 'source': 'EB00' },
          { 'id': 'EB00-ADM', 'nombre': 'Of. Admin.', 'source': 'EB00' },
          { 'id': 'EB00-VIG', 'nombre': 'Vigilancia', 'source': 'EB00' },
          { 'id': 'EB00-ALM', 'nombre': 'Almacén', 'source': 'EB00' },
          { 'id': 'EB00-ARC', 'nombre': 'Archivo', 'source': 'EB00' },
          { 'id': 'EB00-COM', 'nombre': 'Comedor', 'source': 'EB00' },
          { 'id': 'EB00-SV', 'nombre': 'Servicios', 'source': 'EB00' },
          { 'id': 'ERM-CC', 'nombre': 'Cuarto de Control', 'source': 'ERM' },
          { 'id': 'ERM-ADM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
          { 'id': 'ERM-VIG', 'nombre': 'Vigilancia', 'source': 'ERM' },
          { 'id': 'ERM-ALM', 'nombre': 'Almacén', 'source': 'ERM' },
          { 'id': 'VALV-ADM', 'nombre': 'Gabinete', 'source': 'LPGD' },
          { 'id': 'CORP-DIR', 'nombre': 'Dirección', 'source': 'CORP' },
          { 'id': 'CORP-GG', 'nombre': 'Gerencia Gral.', 'source': 'CORP' },
          { 'id': 'CORP-GC', 'nombre': 'Gerencia de Contraloría', 'source': 'CORP' },
          { 'id': 'CORP-C', 'nombre': 'Contabilidad', 'source': 'CORP' },
          { 'id': 'CORP-CP', 'nombre': 'Cuentas por Pagar', 'source': 'CORP' },
          { 'id': 'CORP-F', 'nombre': 'Fiscal', 'source': 'CORP' },
          { 'id': 'CORP-SA', 'nombre': 'Seguimiento Amb.', 'source': 'CORP' },
          { 'id': 'CORP-GR', 'nombre': 'Gerencia de Reg.', 'source': 'CORP' },
          { 'id': 'CORP-ALM', 'nombre': 'Almacén', 'source': 'CORP' },
          { 'id': 'CORP-ALG', 'nombre': 'Almacén GIA', 'source': 'CORP' },
          { 'id': 'CORP-GIS', 'nombre': 'Gerencia Inst. y Sist.', 'source': 'CORP' },
          { 'id': 'CORP-SIT', 'nombre': 'Site', 'source': 'CORP' },
          { 'id': 'CORP-RH', 'nombre': 'Recursos Humanos', 'source': 'CORP' },
          { 'id': 'CORP-LEG', 'nombre': 'Legal', 'source': 'CORP' },
          { 'id': 'CORP-REC', 'nombre': 'Recepción', 'source': 'CORP' },
          { 'id': 'CORP-AUD', 'nombre': 'Auditoría', 'source': 'CORP' },
          { 'id': 'CORP-TES', 'nombre': 'Tesorería', 'source': 'CORP' },
          { 'id': 'CORP-GEN', 'nombre': 'General', 'source': 'CORP' },
          { 'id': 'LPGD-V1', 'nombre': 'Válvula 1', 'source': 'LPGD' },
          { 'id': 'LPGD-V2', 'nombre': 'Válvula 2', 'source': 'LPGD' },
          { 'id': 'LPGD-V3', 'nombre': 'Válvula 3', 'source': 'LPGD' },
          { 'id': 'LPGD-V4', 'nombre': 'Válvula 4', 'source': 'LPGD' },
          { 'id': 'LPGD-V5', 'nombre': 'Válvula 5', 'source': 'LPGD' },
          { 'id': 'LPGD-V6', 'nombre': 'Válvula 6', 'source': 'LPGD' },
          { 'id': 'LPGD-V7', 'nombre': 'Válvula 7', 'source': 'LPGD' },
          { 'id': 'LPGD-V8', 'nombre': 'Válvula 8', 'source': 'LPGD' },
          { 'id': 'LPGD-V9', 'nombre': 'Válvula 9', 'source': 'LPGD' },
          { 'id': 'LPGD-V10', 'nombre': 'Válvula 10', 'source': 'LPGD' },
          { 'id': 'LPGD-V11', 'nombre': 'Válvula 11', 'source': 'LPGD' },
          { 'id': 'LPGD-V12', 'nombre': 'Válvula 12', 'source': 'LPGD' },
          { 'id': 'LPGD-V13', 'nombre': 'Válvula 13', 'source': 'LPGD' },
          { 'id': 'LPGD-V14', 'nombre': 'Válvula 14', 'source': 'LPGD' },
          { 'id': 'LPGD-V15', 'nombre': 'Válvula 15', 'source': 'LPGD' },
          { 'id': 'LPGD-V16', 'nombre': 'Válvula 16', 'source': 'LPGD' },
          { 'id': 'LPGD-V17', 'nombre': 'Válvula 17', 'source': 'LPGD' },
          { 'id': 'LPGD-V18', 'nombre': 'Válvula 18', 'source': 'LPGD' },
          { 'id': 'LPGD-V19', 'nombre': 'Válvula 19', 'source': 'LPGD' },
          { 'id': 'LPGD-V20', 'nombre': 'Válvula 20', 'source': 'LPGD' },
          { 'id': 'LPGD-V21', 'nombre': 'Válvula 21', 'source': 'LPGD' },
          { 'id': 'LPGD-V22', 'nombre': 'Válvula 22', 'source': 'LPGD' },
          { 'id': 'LPGD-V23', 'nombre': 'Válvula 23', 'source': 'LPGD' },
          { 'id': 'LPGD-V24', 'nombre': 'Válvula 24', 'source': 'LPGD' },
          { 'id': 'LPGD-V25', 'nombre': 'Válvula 25', 'source': 'LPGD' },
          { 'id': 'LPGD-V26', 'nombre': 'Válvula 26', 'source': 'LPGD' },
          { 'id': 'LPGD-V1B', 'nombre': 'Válvula 1 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V2B', 'nombre': 'Válvula 2 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V3B', 'nombre': 'Válvula 3 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V4B', 'nombre': 'Válvula 4 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V5B', 'nombre': 'Válvula 5 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-INT', 'nombre': 'Interconexión', 'source': 'LPGD' },
          { 'id': 'TPA-RV', 'nombre': 'Recuperador de vapores', 'source': 'TPA'},
          { 'id': 'TPA-PM', 'nombre': 'Paquete de Medición', 'source': 'TPA'},
          { 'id': 'TPA-BP', 'nombre': 'Bombas de Proceso', 'source': 'TPA'},
          { 'id': 'TPA-SISV', 'nombre': 'Sistema Vickers', 'source': 'TPA'},
          { 'id': 'TPA-SCI', 'nombre': 'Sist. Contra Incendio', 'source': 'TPA'},
          { 'id': 'TPA-CB', 'nombre': 'Cuarto de Baterias', 'source': 'TPA'},
          { 'id': 'EB00-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB00'},
          { 'id': 'EB00-CB', 'nombre': 'Cuarto de Baterias', 'source': 'EB00'},
          { 'id': 'EB00-PM', 'nombre': 'Patín de Medición', 'source': 'EB00'},
          { 'id': 'EB00-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB00'},
          { 'id': 'EB00-TR', 'nombre': 'Tren de Regulación', 'source': 'EB00'},
          { 'id': 'ERM-PM', 'nombre': 'Patín de Medición', 'source': 'ERM'},
          { 'id': 'ERM-SAL', 'nombre': 'Salida IRGE', 'source': 'ERM'},
          { 'id': 'ERM-TD', 'nombre': 'Trampa de Diablos', 'source': 'ERM'},
          { 'id': 'ERM-TP', 'nombre': 'Tanque Pulmón', 'source': 'ERM'},
          { 'id': 'ERM-TPRG', 'nombre': 'Tanque de Purga', 'source': 'ERM'},
          { 'id': 'ERM-TR', 'nombre': 'Tren de Regulación', 'source': 'ERM'},
          { 'id': 'ERM-JEF', 'nombre': 'Jefatura', 'source': 'ERM'},
          { 'id': 'ERM-COM', 'nombre': 'Comedor', 'source': 'ERM'},
          { 'id': 'ERM-CEL', 'nombre': 'Cuarto Eléctrico', 'source': 'ERM'},
          { 'id': 'EB04-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB04'},
          { 'id': 'EB04-CAB', 'nombre': 'Cabezales', 'source': 'EB04'},
          { 'id': 'EB04-CB', 'nombre': 'Cobertizo de Bombas', 'source': 'EB04'},
          { 'id': 'EB04-COC', 'nombre': 'Cocina', 'source': 'EB04'},
          { 'id': 'EB04-CTE', 'nombre': 'Cuarto Eléctrico', 'source': 'EB04'},
          { 'id': 'EB04-GEN', 'nombre': 'Generadores', 'source': 'EB04'},
          { 'id': 'EB04-PM', 'nombre': 'Patín de Medición', 'source': 'EB04'},
          { 'id': 'EB04-RP', 'nombre': 'Residuos Peligrosos', 'source': 'EB04'},
          { 'id': 'EB04-TALL', 'nombre': 'Taller y Almacén', 'source': 'EB04'},
          { 'id': 'EB04-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB04'},
          { 'id': 'EB04-TORG', 'nombre': 'Tanque de Purga', 'source': 'EB04'},
          { 'id': 'EB04-TR', 'nombre': 'Tren de Regulación', 'source': 'EB04'},
          { 'id': 'EB04-TRA', 'nombre': 'Transformador', 'source': 'EB04'},
          { 'id': 'IRGE-BOM', 'nombre': 'Bombas LPG', 'source': 'IRGE'},
          { 'id': 'IRGE-BP', 'nombre': 'Bombas de Proceso', 'source': 'IRGE'},
          { 'id': 'IRGE-CB', 'nombre': 'Cuarto de Bombas', 'source': 'IRGE'},
          { 'id': 'IRGE-CCM', 'nombre': 'CCM', 'source': 'IRGE'},
          { 'id': 'IRGE-CI', 'nombre': 'Red C.I.', 'source': 'IRGE'},
          { 'id': 'IRGE-COMP', 'nombre': 'Area de Compresores', 'source': 'IRGE'},
          { 'id': 'IRGE-CONT', 'nombre': 'Contabilidad', 'source': 'IRGE'},
          { 'id': 'IRGE-CUB', 'nombre': 'Cubeta', 'source': 'IRGE'},
          { 'id': 'IRGE-ESF', 'nombre': 'Esferas', 'source': 'IRGE'},
          { 'id': 'IRGE-LLEN', 'nombre': 'Llenaderas', 'source': 'IRGE'},
          { 'id': 'IRGE-MANT', 'nombre': 'Of. Mantenimiento', 'source': 'IRGE'},
          { 'id': 'IRGE-PROP', 'nombre': 'Of. Propangol', 'source': 'IRGE'},
          { 'id': 'IRGE-TA', 'nombre': 'Tanque de Agua', 'source': 'IRGE'},
          { 'id': 'IRGE-TD', 'nombre': 'Trampa de Diablos', 'source': 'IRGE'},
          { 'id': 'IRGE-TP', 'nombre': 'Tanque Pulmón', 'source': 'IRGE'},
          { 'id': 'IRGE-TR', 'nombre': 'Tren de Regulación', 'source': 'IRGE'},
          { 'id': 'IRGE-TRA', 'nombre': 'Area de Trasiegos', 'source': 'IRGE'},
          { 'id': 'IRGE-TALL', 'nombre': 'Taller', 'source': 'IRGE'},
          
        ],
        oficinasSel: [],
        ubicaciones: [
          { nombre: 'IRGE', valor: 'IRGE' },
          { nombre: 'TPA', valor: 'TPA' },
          { nombre: 'CORPORATIVO', valor: 'CORP' },
          { nombre: 'DUCTO', valor: 'LPGD' },
          { nombre: 'EB00', valor: 'EB00' },
          { nombre: 'EB01', valor: 'EB01' },
          { nombre: 'EB02', valor: 'EB02' },
          { nombre: 'EB03', valor: 'EB03' },
          { nombre: 'EB04', valor: 'EB04' },
          { nombre: 'ERM-TLAUTLA', valor: 'ERM' }
        ],
        ubicacionSel: null,
        oficinaSelected: null,
        hash: '',
        myObjPrestamo: {},
        clavePrest: '',
        idBD: '',
        origen: '',
        almacenes: [],

      }
    },
    watch: {
      ubicacionSel() {
        this.oficinasSel = this.oficinas.filter( ofi => ofi.source === this.ubicacionSel)
      },
      area() {
        this.obtenerJefe()
      }
    },
    methods: {
      iniciarComponentes() {
        this.obtenerUsuarios()
      },
      obtenerUsuarios() {
        usuariosServices.getUsuarios()
          .then(res => {
            console.log(res)
            if (res.length > 0) {
                let uRecibe = res.filter(user => user.id !== '1538165924968' && user.id !== '1565972235101' && user.id !== '1556122430935' && parseInt(user.categoria) < 5)
                let uAutoriza = res.filter(user => parseInt(user.categoria) == 0 && user.puesto !== '000' || parseInt(user.categoria) == 2 && user.departamento === '1' || parseInt(user.categoria) == 2 && user.departamento === '3')

                if (uRecibe.length > 0) {
                
                  uRecibe.forEach(element => {
                    let tipoObj = {}
                    tipoObj = {
                      id: element.id,
                      text: `${element.nombre}`
                    }
                    this.usuarios.push(tipoObj)
                  })
                }

                this.usuarios_Recibe = this.usuarios
                this.usuarios_Autoriza = uAutoriza
                this.isLoading = false
                this.obtenerJefe()
              } else {
                this.isLoading = false
              }
          })
      },

      checkForm () {
        this.datosFaltantes = []
        if (this.area && this.ubicacionSel && this.oficinaSelected && Object.keys(this.usuarioRecibe).length > 0 && this.fecha) {
          this.savePrestamo()
        } else {
          
          if (!this.area) {
            this.datosFaltantes.push('El Área es requerida.')
          }
          if (!this.ubicacionSel) {
            this.datosFaltantes.push('El Ubicación es requerido.')
          }
          if (!this.oficinaSelected) {
            this.datosFaltantes.push('La Oficina es requerida.')
          }

          if (Object.keys(this.usuarioRecibe).length == 0) {
            this.datosFaltantes.push('El Usuario que recibe es requerido.')
          }

          if (Object.keys(this.fecha).length == 0) {
            this.datosFaltantes.push('El Usuario que recibe es requerido.')
          }

        }
      },

      savePrestamo () {
        this.isLoading = true
        let ahora = moment()
        let fechaI = ahora.startOf('month').format('YYYY-MM-DD')
        let fechaF = ahora.endOf('month').format('YYYY-MM-DD')
        
        InventarioServices.countPrestamos(fechaI, fechaF)
          .then(res => {
            console.log(res)
            
            let hoy = moment()
            let month = hoy.format('MM')
            let year = hoy.format('YY')
            this.fechaReg = hoy.format('YYYY-MM-DD HH:mm:ss')
      
            switch (true) {
              case parseInt(res[0].total) < 10:
                this.clavePrest = `DUCTER-PREST-${year}${month}_00${res[0].total}`
                break
              case parseInt(res[0].total) < 100:
                this.clavePrest = `DUCTER-PREST-${year}${month}_0${res[0].total}`
                break
              case parseInt(res[0].total) < 1000:
                this.clavePrest = `DUCTER-PREST-${year}${month}_${res[0].total}`
                break
              default:
                this.clavePrest = `DUCTER-PREST-${year}${month}_00${res[0].total}`
                break
            }
            console.log(this.clavePrest)
            
            let hash = ''
            InventarioServices.addPrestamo(this.clavePrest, this.fechaReg, this.userLogin.id, 
            this.userLogin.nombre, this.usuarioRecibe.id, this.usuarioRecibe.text, this.area, 
            this.origen.ubicacion, this.origen.clave, this.ubicacionSel, this.oficinaSelected, hash)
              .then(res => {

                if (res.success) {
                  this.idBD = res.getData
                  
                  this.myObjPrestamo = {
                    id: this.idBD,
                    clavePrestamo: this.clavePrest,
                    fechaReg: this.fechaReg,
                    fecha_entrega: this.fecha,
                    id_entrega: this.userLogin.id,
                    entrega: this.userLogin.nombre,
                    id_recibe: this.usuarioRecibe.id,
                    recibe: this.usuarioRecibe.text,
                    area: this.area,
                    origen: this.origen.ubicacion,
                    ofi_origen: this.origen.clave,
                    ubicacion: this.ubicacionSel,
                    ubicacion_ofi: this.oficinaSelected,
                    firma: 'E',
                    firma_entrega: '',
                    firma_recibe: '',
                    estado: 1,
                    hash: hash
                  }
                  this.guardarItems()
                } else {
                  this.displayToast('bubble',`Error: ${res.respuesta}`, 'ban', 'OK')
                }
              })
              .catch((e)=> {
                this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
          })
          .catch((err)=> {
            this.displayToast('bubble',`Error: ${err.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },

      guardarItems () {
        if (this.itemsGuardados == this.articulos_Salida.length) {
          this.displayToast('toasted-primary', 'La Asignación se ha registrado correctamente.','done', 'ok')
          this.firmarPrestamo(this.myObjPrestamo)
        } else {
          let ahora2 = Date.now()
          let idUbi = `${ahora2.toString()}${this.itemsGuardados}p`

          InventarioServices.addItemToPrestamos(this.articulos_Salida[this.itemsGuardados].id,this.idBD, idUbi, this.articulos_Salida[this.itemsGuardados].serie, this.fecha)
            .then(dataIA => {
              if (dataIA.success) {
                InventarioServices.addUbicacion(idUbi,this.articulos_Salida[this.itemsGuardados].id,this.fechaReg,this.ubicacionSel,this.oficinaSelected,this.userLogin.id,this.userLogin.nombre,this.usuarioRecibe.id, this.usuarioRecibe.text, '3')
                  .then(resUbi => {
                    if (resUbi.success) {
                      this.itemsGuardados = this.itemsGuardados + 1
                    } else {
                      this.itemsGuardados = this.itemsGuardados + 1
                      this.displayToast('bubble',`Error: ${resUbi.respuesta}`, 'ban', 'OK')
                    }
                    this.guardarItems()
                  })
                  .catch((e) => {
                    this.itemsGuardados = this.itemsGuardados + 1
                    this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                    this.isLoading = false
                    this.guardarItems()
                  })
              } else {
                this.itemsGuardados = this.itemsGuardados + 1
                this.displayToast('bubble',`Error: ${dataIA.respuesta}`, 'ban', 'OK')
                this.guardarItems()
              }
            })
            .catch((e) => {
              this.itemsGuardados = this.itemsGuardados + 1
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
              this.isLoading = false
              this.guardarItems()
            })
        }
      },

      firmarPrestamo(prestamo) {
          this.$store.commit('firmarPrestamo', prestamo)
          this.$store.commit('limpiarArticulos_Salida')
          this.$router.push('/Inventario/Prestamos/Firma')
      },

      encriptarId()  {
        this.isLoading = true
        try {
          const cryptr = new Cryptr(evall)
          const encryptedString = cryptr.encrypt(this.clavePrest)
          return encryptedString
        } catch (error) {
          console.log(error)
          return error
        }
      },

      obtenerJefe () {
      
        let objAutoriza = {}
        if (this.almacenSelect === "c") {
          console.log('almacen cede')
          switch (this.userLogin.ubicacion) {
            case 'TPA':
              console.log('TPA')
              objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '006')
              break
            case 'IRGE':
              console.log('IRGE')
              objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '004')
              break
            case 'CORP':
              console.log('CORP')
              objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '001')
              break
          
            default:
              objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '001')
              break
          }
          this.autoriza = Object.assign({}, this.autoriza, objAutoriza)
        } else {
          console.log('GIA')
          switch (this.area) {
            case '1':
              console.log('1')
              objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '210' )
              break
            case '2':
              console.log('2')
              objAutoriza = this.usuarios_Autoriza.find( u => u.puesto === '002' )
              break
            case '3':
              console.log('3')
              objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '230' )
              break
          
            default:
              objAutoriza = {}
              break
          }
          this.autoriza = Object.assign({}, this.autoriza, objAutoriza)
        }
      },

      backPage() {
        this.$router.back()
      },
      
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      obtenerAlmacenes() {
      InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },
    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerAlmacenOrigen() {
      this.almacenes.map( alm => {
        const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
        if (encontrado) {
          this.origen = alm
        }
      })
      this.iniciarComponentes()
    },
    },
    created () {
      this.obtenerAlmacenes()
    },
    computed: {
      ...mapState(['userLogin', 'articulos_Salida', 'almacenSelect'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/NuevoPrestamo.vue